// import moment from "moment";
import { getSessionStorageItem } from "../SessionStorageMethod/getSessionStorageItem";
import { showToast } from "ui-components";
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
import html2canvas from "html2canvas";
// ar: Arabic he: Hebrew fa: Persian (Farsi) ur: Urdu
const rtlLanguages = ["ar", "he", "fa", "ur"]; // Add other RTL languages if needed

export const isRtl = (language: string) => rtlLanguages.includes(language);

// check component disability
export const isDisable = (functionBehavior: any) => {
  return functionBehavior === "disable" ? true : false;
};

// check component hidden or not
export const isHide = (functionBehavior: any) => {
  return functionBehavior === "hide" ? false : true;
};

export const initialReviewData = {
  type: getSessionStorageItem("Type") || "",
  titleHeadContent: getSessionStorageItem("titleHeadContent") || "",
};

// Utility function to format the timer value into minutes and seconds
export const formatTime = (time: number): string => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;
  return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
};

export const updateProgressBarAndColors = (
  questionSet: any[],
  currentQuestionIndex: number,
  questionData: any,
  assessmentDetailsData: any,
  setProgressBar: (callback: any) => void,
  setSubQuestionColors: (colors: string[]) => void,
  setApiError: (error: boolean) => void,
) => {
  // to calculate progress bar width
  const progressBar = (currentQuestionIndex: number, totalQuestion: number) => {
    const equalWidth = 100 / (totalQuestion - 1);
    const widthPerCal = equalWidth * currentQuestionIndex;
    return widthPerCal - equalWidth;
  };
  if (questionSet?.length > currentQuestionIndex) {
    if (questionData?.data?.currentQuestion !== 1) {
      setProgressBar((prev: any) => {
        const updateData =
          prev.progressbar < 100
            ? {
                progressbar: progressBar(
                  questionData?.data?.currentQuestion,
                  assessmentDetailsData?.totalQuestions,
                ),
                index: prev.index + 1,
              }
            : prev;
        return updateData;
      });
    }
    if (assessmentDetailsData?.applicationStatus === "Initiated") {
      const initialUpdateData = Array.from(
        { length: questionSet.length },
        (_, index) =>
          index < questionData?.data?.currentQuestion
            ? "var(--primary-green)"
            : "var(--division-grey)",
      );
      const updatedColors = [...initialUpdateData];
      setSubQuestionColors(updatedColors);
    } else {
      const initialUpdateData = Array.from(
        { length: questionSet.length },
        (_, index) =>
          index === 0 ? "var(--primary-green)" : "var(--division-grey)",
      );
      if (questionData?.data?.currentQuestion > 1) {
        const updatedColors = Array.from(
          { length: questionSet.length },
          (_, index) =>
            index < questionData?.data?.currentQuestion
              ? "var(--primary-green)"
              : initialUpdateData[index],
        );
        setSubQuestionColors(updatedColors);
      } else {
        setSubQuestionColors(initialUpdateData);
      }
    }
    setApiError(false);
  }
};

export function extractLanguage(url: string): string | null {
  const parts = url.split("/");
  if (parts.length < 3) {
    return null; // URL doesn't have enough parts
  }
  return parts[1]; // Return the second part of the URL
}
// start edited assessment data

// transform edited custom question

// end edited assessment data
// extract path from url
export function extractPathFromUrl(url: string): string | null {
  // eslint-disable-next-line no-useless-escape
  const match = url.match(/\/a\/([^\/?#]+)/);
  return match ? match[0].substring(1) : null;
}

// handle error while calling api
export function handleError(error: any, isShowToast?: boolean) {
  if (error?.customMessage) {
    if (!isShowToast) {
      showToast(error?.customMessage, "error");
    }
  } else {
    console.log("error", error);
  }
}

// if we have uniqueId then use that otherwise use new
export const foundUniqueId = (id: string | undefined | null) => {
  if (id) {
    return id;
  } else {
    const uniqueId = uuidv4();
    localStorage.setItem("tempUniqueId", uniqueId);
    return uniqueId;
  }
};

export const convertDate = (
  dateTime: string,
  withComma?: boolean,
  withTime?: boolean,
) => {
  const days: { [key: string]: string } = {
    Mon: "Mon",
    Tue: "Tue",
    Wed: "Wed",
    Thu: "Thu",
    Fri: "Fri",
    Sat: "Sat",
    Sun: "Sun",
  };
  const dateFormat = moment(dateTime).format("llll").split(",");
  const year = dateFormat[2].split(" ")[1];
  const time = dateFormat[2].split(" ")[2] + " " + dateFormat[2].split(" ")[3];
  const date = dateFormat[1].split(" ")[2];
  const month = dateFormat[1].split(" ")[1];
  const day = dateFormat[0];
  const timeZoneAbbreviation = moment.tz(moment.tz.guess()).format("z");
  if (withComma) {
    return `${date} ${month} ${year}, ${days[day]}`;
  } else if (withTime) {
    return `${date} ${month} ${year}, ${days[day]} ${time} (${timeZoneAbbreviation})`;
  } else {
    return `${date} ${month} ${year} (${days[day]})`;
  }
};

export const handleKeyPressSearch = (
  e: React.KeyboardEvent<HTMLInputElement>,
) => {
  if (e.key === "Enter") {
    e.preventDefault(); // Prevent default form submission on Enter key
  }
};

interface ISkillData {
  skillName: string;
  skillIcon: string;
  difficultyLevel: string;
  totalQuestions: number;
}

// manage the duplicate skill and mention the difficultyLevel
export function manageDuplicateSkills(data: ISkillData[]): any {
  if (data) {
    return (
      data.map((skill) => ({
        ...skill,
        skillName: `${skill.skillName} - ${skill.difficultyLevel}`,
      })) ?? []
    );
  } else {
    return null;
  }
}

// user login User Data
export const loginUserData = {
  email: "",
  password: "",
  confirmPassword: "",
  oldPassword: "",
};

// decode text
export function convertToText(value: string) {
  if (value === undefined || value === null) {
    return "";
  } else {
    return atob(value);
  }
}

// api for to get ip and geolocation address
export const geoLocationapiClient = async () => {
  const res = await fetch("https://ipapi.co/json/");
  const ipData = res?.json();
  return ipData;
};

// get pascal string
export function toPascalCase(str: string) {
  return str
    ?.toLowerCase() // Convert the entire string to lowercase
    .split(" ") // Split the string by spaces
    .filter((word) => word) // Remove any empty strings from the array
    .map((word) => {
      // Capitalize the first letter of each word and concatenate with the rest of the word
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" "); // Join all words together without spaces
}

// get camel case string
export function toCamelCase(str: string) {
  return str
    .split(" ")
    .map((word, index) => {
      const lowerCasedWord = word.toLowerCase();
      return index === 0
        ? lowerCasedWord
        : lowerCasedWord.charAt(0).toUpperCase() + lowerCasedWord.slice(1);
    })
    .join("");
}

// this function is used for only to attempt number of question
export const attempFun = (ele: number) => {
  switch (ele) {
    case 1:
      return "1st";
    case 2:
      return "2nd";
    case 3:
      return "3rd";
    case 4:
      return "4th";
    case 5:
      return "last";
  }
};

export const exitFullScreen = () => {
  if (document.fullscreenElement) {
    document.exitFullscreen().catch((e) => {
      console.error(e);
    });
  }
};

//calculate length of text
export function calculateMinusAmount(
  increasingValue: number,
  lastCount: number,
) {
  return lastCount - increasingValue;
}

// start generate uuid
export const generateUUID = () => {
  const hexDigits = "0123456789abcdef";
  const segments = [8, 4, 4, 4, 12];

  return segments
    .map((segment) =>
      Array.from({ length: segment }, () =>
        hexDigits.charAt(Math.floor(Math.random() * 16)),
      ).join(""),
    )
    .join("-");
};

export const isMobileResolution = () => {
  return window.innerWidth <= 767;
};

// type for engagement or job type
export const typesKeyPair: any = {
  onSite: "On Site",
  hybrid: "Hybrid",
  remote: "Remote",
  fullTime: "Full Time",
  partTime: "Part Time",
  contract: "Contract",
  internship: "Internship",
};

// Function to detect if the browser is Safari
export function isSafari() {
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes("safari") && !ua.includes("chrome");
}
// calculate time in min, hour, month, year ago
export function getTimeDifference(
  inputTime: string,
  minuteText: string,
  hourText: string,
  dayText: string,
  monthText: string,
  yearText: string,
  agoText: string,
  justNowText: string,
) {
  const currentTime = moment();
  if (!inputTime) {
    return undefined;
  }

  let parsedTime;
  if (isSafari()) {
    // If Safari, try to format inputTime as ISO 8601 or another compatible format
    parsedTime = moment(inputTime, moment.ISO_8601);
    if (!parsedTime.isValid()) {
      // Attempt to fix the input format for Safari
      parsedTime = moment(
        inputTime.replace(/-/g, "/").replace("T", " ").split(".")[0] +
          " +00:00",
      );
    }
  } else {
    // For other browsers, rely on moment's auto parsing or ISO 8601 format
    parsedTime = moment(inputTime);
  }
  const diffMinutes = currentTime.diff(parsedTime, "minutes");
  const diffHours = currentTime.diff(parsedTime, "hours");
  const diffDays = currentTime.diff(parsedTime, "days");
  const diffMonths = currentTime.diff(parsedTime, "months");
  const diffYears = currentTime.diff(parsedTime, "years");
  if (diffMinutes < 1) {
    return `${justNowText}`;
  } else if (diffMinutes < 60) {
    return `${`${diffMinutes} ${minuteText}`} ${agoText}`;
  } else if (diffHours < 24) {
    return `${`${diffHours} ${hourText}`} ${agoText}`;
  } else if (diffDays < 30) {
    return `${`${diffDays} ${dayText}`} ${agoText}`;
  } else if (diffMonths < 12) {
    return `${`${diffMonths} ${monthText}`} ${agoText}`;
  } else {
    return `${`${diffYears} ${yearText}`} ${agoText}`;
  }
}

// fucntion to convert First letter captial in a word
export const capitalizeFirstLetter = (str: any) => {
  return str?.charAt(0)?.toUpperCase() + str?.slice(1);
};

// function to showMore/showLess
export const expandText = (ref: any, setIsExpanded: any, isExpanded: any) => {
  ref.current.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
  setIsExpanded(!isExpanded);
};

// Function to get the truncated text (first two lines, approximated by word count)
export const getTruncatedText = (text: string, wordLimit: number) => {
  const words = text?.split(" ");
  return words?.length > wordLimit
    ? words?.slice(0, wordLimit)?.join(" ") + "..."
    : text;
};

export const redirectTo = (url: any) => {
  window.open(url, "_blank");
};

export const getCurrentYear = () => {
  return new Date().getFullYear();
};

// check demo url
export const isDemo =
  process.env.REACT_APP_API === "https://demo.dev.evluate.com/";

// Function to draw component as image like screenshot
export const captureScreenshot = (ref: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    html2canvas(ref?.current, {
      useCORS: true,
    })
      .then((canvas: any) => {
        canvas.toBlob((blob: any) => {
          if (blob) {
            const file = new File([blob], "screenshot.png", {
              type: "image/png",
            });
            const fakeEvent = {
              target: {
                files: [file],
                value: "",
              },
            };
            resolve(fakeEvent);
          } else {
            console.error("Failed to convert canvas to Blob.");
            reject("Blob conversion failed");
          }
        }, "image/png");
      })
      .catch((error: any) => {
        console.error("html2canvas error:", error);
        reject(error);
      });
  });
};

// function to set queryparams when select filters
export const setInQueryParams = (
  queryParams: any,
  key: string,
  value: any,
  navigate: any,
) => {
  queryParams.set(key, value);
  navigate(`?${queryParams.toString()}`, { replace: true });
};
// function to remove queryparams
export const removeFromQueryParams = (
  queryParams: any,
  key: string,
  navigate: any,
) => {
  queryParams.delete(key);
  navigate(`?${queryParams.toString()}`, { replace: true });
};
